import type { QueryClient } from "@tanstack/react-query"
import { createRootRouteWithContext, Outlet, useMatches } from "@tanstack/react-router"
import { useEffect } from "react"

import { DefaultRouteError } from "#components/errors/default-route-error.tsx"
import { NotFoundPage } from "#pages/404/_404.tsx"
import type { MeStoreLoggedIn, MeStoreNotLoggedIn } from "#store/user-info.ts"

declare module "@tanstack/react-router" {
  interface StaticDataRouteOption {
    title?: string
    breadcrumbs?: Array<{ title: string; to: string }>
  }
}

type RouterContext = {
  queryClient: QueryClient
  userInfo: MeStoreLoggedIn | MeStoreNotLoggedIn
}

const RootComponent = () => {
  const matches = useMatches()

  useEffect(() => {
    const match = [...matches]
      .reverse()
      .find((m) => (m.loaderData as { title?: string })?.title || m.staticData?.title)

    const title =
      (match?.loaderData as { title?: string })?.title ?? match?.staticData?.title

    document.title = title ? `${title} - Atlant` : "Atlant"
  }, [matches])

  return <Outlet />
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFoundPage,
  errorComponent: ({ error }) => <DefaultRouteError error={error} />,
})
